module.exports = __webpack_public_path__ + "static/img/motorbike-grey.e7f020f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-grey.svg
// module id = cCKB
// module chunks = 74